export default __webpack_public_path__ + "static/media/snowflake.720fc953.png";